import { withTrackEvent, actionNames, objectTypes } from "@newsela/snitch";

import Link from "@/components/Link";

const LinkWithTrackEvent = withTrackEvent(Link);

interface ReadingSkillSearchLinkProps {
  skillSlug: string;
  skillName?: string | undefined;
}

const ReadingSkillSearchLink = ({
  skillSlug,
  skillName,
}: ReadingSkillSearchLinkProps) => {
  return (
    <LinkWithTrackEvent
      href={`/search/?reading_skills=${skillSlug}`}
      actionName={actionNames.navigate}
      objectType={objectTypes.fullPage}
      streamProperties={{
        description:
          "Teacher Reporting - student reading skills - navigate to search",
      }}
      isInline
      childrenWrapperElement="span"
    >
      Find articles that match {skillName || "this skill"}
    </LinkWithTrackEvent>
  );
};

export default ReadingSkillSearchLink;
